@if (this.clientData?.result$ | async; as result) {
    @if (result.value?.data; as clientData) {

        @if (result.isLoading) {
            <cll-spinner />
        }

        @if (result.error; as error) {
            <app-error-panel [error]="error" />
        }
        <div class="accordion-container">
            <cll-card-divider />
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Reference code'" [data]="clientData.reference"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'NHS number'" [data]="clientData.nhs_number"/>
            </div>

            <div class="accordion-row-field">
                <app-accordion-item [label]="'Full name'" [data]="clientData.person | personName"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Preferred name'" [data]="clientData.person.preferred_name"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Pronouns'" [data]="clientData.person.pronouns"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item [label]="'Date of birth'" [data]="clientData.person.date_of_birth | appDate: 'WITH_AGE'"/>
            </div>
            <div class="accordion-row-field">
                <app-accordion-item 
                [label]="'Birth sex'" 
                [data]="clientData.person.birth_sex === 'm' ? 'Male' : 
                        clientData.person.birth_sex === 'f' ? 'Female' : 'Indeterminate'"
              />    
            </div>

            <cll-card-footer>
                <button cll-tonal-button (click)="editGeneralInformation()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        </div>
    }
}
